<template>
    <div>
        <b-row v-for="name in value" :key="name.id">
            <b-col>
                {{name.name}}
            </b-col>
        </b-row>

        <b-row v-if="!value || value.length === 0">
            <b-col>
                <p>No trade name provided.</p>
            </b-col>
        </b-row>
    </div>
</template>

<script>  
export default {
    props: {
        value: Array,
    },
}
</script>

<style>
</style>
